import { div, h2, p, udex } from '../../../scripts/dom-builder.js';
import { isM, isS, isXS } from '../../../scripts/utils/breakpoints-utils.js';
import checkIsFromSAP from '../../../scripts/utils/sap-utils.js';
import getI18next from '../../../scripts/utils/translations/get-translations.js';
import {
  ECCN_MATRIX_COLUMN_WIDTHS,
  ECCN_MATRIX_MAX_COLUMNS,
} from '../finder-eccn-matrix.constants.js';

function getCustomColumns() {
  if (isXS()) {
    return ECCN_MATRIX_COLUMN_WIDTHS.XS.join(' ');
  }
  if (isS()) {
    return ECCN_MATRIX_COLUMN_WIDTHS.SM.join(' ');
  }
  if (isM()) {
    return ECCN_MATRIX_COLUMN_WIDTHS.MD.join(' ');
  }
  return ECCN_MATRIX_COLUMN_WIDTHS.LG.join(' ');
}

export function getValueNode(val = '') {
  const span = document.createElement('span');
  if (/<\/?strong>/.test(val)) {
    span.innerHTML = val;
  } else {
    span.textContent = val;
  }
  return span;
}

function createRow(headers, row) {
  const cells = headers.map((h, index) => {
    const content = row[h] ?? '';
    const valueNode = getValueNode(content);

    if (index === 0) {
      const allKeys = Object.keys(row);
      const url = row[allKeys[ECCN_MATRIX_MAX_COLUMNS]] || '';
      if (url && checkIsFromSAP()) {
        return udex(
          'table-cell',
          udex(
            'link',
            {
              href: url,
              target: '_blank',
              dataActivityMapRegion: 'body|finder-eccn-matrix',
            },
            valueNode,
          ),
        );
      }
    }

    return udex('table-cell', valueNode);
  });

  return udex('table-row', ...cells);
}

export async function getTable(headers, rows) {
  const i18next = await getI18next();

  const noData = div(
    { slot: 'noData', class: 'eccn-no-data' },
    h2(
      i18next.t(
        'Finder.Variation.ECCN.Results.NoResults.Headline.Text',
        'There are no matching search results',
      ),
    ),
    p(
      i18next.t(
        'Finder.Variation.ECCN.Results.NoResults.Message.Text',
        'Check the spelling of all words or search for a new keyword',
      ),
    ),
  );

  const headerRow = udex(
    'table-header-row',
    { slot: 'headerRow' },
    ...headers.map((h) => udex('table-header-cell', h)),
  );

  const tableRows = rows.map((row) => createRow(headers, row));

  const tableProps = {
    stickyHeader: true,
    noDataText: ' ',
    loading: true,
    customColumns: rows?.length ? getCustomColumns() : null,
  };

  const table = udex(
    'table',
    tableProps,
    noData,
    headerRow,
    ...(rows?.length ? tableRows : []),
  );

  if (!rows?.length) {
    table.classList.add('is-empty');
  }

  table.loading = false;
  return table;
}
